const cards = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20style%20night%20scene%20with%20camera%20flashes%20and%20silhouetted%20figures%2C%20warm%20amber%20street%20lights%2C%20mysterious%20urban%20atmosphere%2C%20cinematic%20composition%2C%20dark%20background%20with%20bright%20highlights%2C%20editorial%20photography%20style&width=600&height=400&seq=card-img-1&orientation=landscape',
    tag: '明星八卦',
    title: '某顶流男星塌房全记录：从被拍到回应仅用三小时',
    excerpt: '狗仔蹲守三个月终获实锤照片，男方工作室凌晨火速发声明否认，但网友逐帧分析后发现多处疑点。',
    time: '2小时前',
    views: '12.8万',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20setup%20with%20ring%20light%20and%20microphone%20in%20dramatic%20red%20and%20dark%20lighting%2C%20professional%20streamer%20background%2C%20bold%20contrast%2C%20cinematic%20atmosphere%2C%20mysterious%20vibe&width=600&height=400&seq=card-img-2&orientation=landscape',
    tag: '网红翻车',
    title: '千万粉主播直播口误酿大祸：三家品牌火速解约',
    excerpt: '该网红在直播中不当言论被观众截屏传播，合作品牌连夜发声明终止合作，损失或超千万。',
    time: '3小时前',
    views: '9.6万',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20chat%20screenshots%20floating%20in%20dark%20space%20with%20red%20glow%20accents%2C%20digital%20privacy%20breach%20concept%2C%20dramatic%20atmosphere%2C%20modern%20editorial%20style%2C%20mysterious%20and%20suspenseful%20mood&width=600&height=400&seq=card-img-3&orientation=landscape',
    tag: '独家爆料',
    title: '选秀节目私下聊天记录外泄：多位选手人设崩塌',
    excerpt: '涉及当红选手的群聊截图在社交平台疯狂传播，节目组回应正在核实真实性但未明确否认。',
    time: '5小时前',
    views: '15.3万',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Corporate%20office%20documents%20scattered%20on%20dark%20desk%20with%20dramatic%20side%20lighting%2C%20confidential%20stamp%20visible%2C%20mysterious%20atmosphere%2C%20warm%20tungsten%20light%2C%20cinematic%20noir%20style%2C%20suspenseful%20editorial%20photography&width=600&height=400&seq=card-img-4&orientation=landscape',
    tag: '行业地震',
    title: '影视公司内部邮件泄露：亿元项目因主角丑闻停摆',
    excerpt: '邮件内容显示因主演出轨导致投资方紧急撤资，剧组已全面停工等待换角，损失难以估量。',
    time: '6小时前',
    views: '8.2万',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20social%20media%20trending%20topics%20in%20dark%20environment%20with%20dramatic%20red%20accent%20lighting%2C%20modern%20digital%20culture%20aesthetic%2C%20warm%20glow%2C%20editorial%20product%20photography%20style&width=600&height=400&seq=card-img-5&orientation=landscape',
    tag: '平台动态',
    title: '直播平台官方通报刷单事件：涉事主播永久封禁',
    excerpt: '经过一周调查，平台发布正式公告，对涉事主播进行永久封禁处理并移送监管部门进一步追责。',
    time: '8小时前',
    views: '7.5万',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20concept%20of%20online%20community%20unfollowing%20with%20falling%20social%20media%20numbers%20in%20dark%20tones%2C%20dramatic%20red%20and%20amber%20color%20scheme%2C%20digital%20culture%20commentary%2C%20editorial%20style%20with%20bold%20composition&width=600&height=400&seq=card-img-6&orientation=landscape',
    tag: '二次元圈',
    title: 'B站顶流UP主人设崩塌：早年争议言论全被扒出',
    excerpt: '网友考古发现该UP主多年前发布于社交平台的不当言论，超话排名一夜暴跌引发粉丝脱粉潮。',
    time: '10小时前',
    views: '11.1万',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          热门内容<i className="ri-article-line text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">大家都在看的爆料</p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <article key={card.id} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 group cursor-pointer hover:border-primary-200/50 transition-colors">
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 flex-wrap mb-2">
                  <span className="text-xs font-semibold text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{card.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 leading-snug line-clamp-2">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{card.views} 阅读</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}